/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Node } from 'react';

import React from 'react';
import { Navigate } from 'react-router-dom';

type Props = {
  children: Node,
  isAuthorized: boolean,
  redirectTo: string,
  replace?: boolean,
};

// `replace` defaults to false (react/require-default-props needs a default, and Flow rejects an
// `undefined` default for a boolean), but Navigate only ever receives `true` or `undefined`: existing
// callers therefore pass Navigate exactly what they always did -- no replace value -- which their
// specs (e.g. RequireExtractionPermissionSpec) assert.
const RequireAuthorization = ({
  children,
  isAuthorized,
  redirectTo,
  replace = false,
}: Props): Node =>
  isAuthorized ? children : <Navigate to={redirectTo} replace={replace || undefined} />;

export default RequireAuthorization;
